import { createSlice } from "@reduxjs/toolkit";

export const usersSlice = createSlice({
  name: "users",
  initialState: { users: [], status: "idle", error: null },
  reducers: {
    setUsers: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.users = action.payload;
      state.status = "ready";
      state.error = null;
    },
    setUsersStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearUsers: (state) => {
      state.users = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { setUsers, setUsersStatus, clearUsers } = usersSlice.actions;

export default usersSlice.reducer;
